import type { Map2 } from './map-2';

import { Environment } from '../../../environments/environment';

// Snaps the map back to the default view when filters are reset (ApplyExtentFilter intentionally
// skips this case since the default lat/lng/lvl is indistinguishable from "unset").
export function ResetMapView(this: Map2): void {
  if (this.filteringService.resetCount() === 0) {
    return;
  }

  this.center.set(Environment.mapCenter);
  this.zoom.set(Environment.mapZoom);
  void this.mapView?.goTo({ center: Environment.mapCenter, zoom: Environment.mapZoom });
}
